import { z } from 'zod';

/**
 * Zod schemas for payment plan-related entities
 * These provide runtime validation and type inference
 */

// PaymentPlanInstallment schema
const paymentPlanInstallmentSchema = z.object({
  id: z.string(),
  dueDate: z.string(),
  amount: z.number().nonnegative(),
  status: z.enum(['pending', 'paid', 'overdue', 'cancelled'] as const),
  paidDate: z.string().optional(),
  receivableId: z.string().optional(),
  paidAmount: z.number().nonnegative().optional(),
  notes: z.string().optional(),
});

// PaymentPlan schema
export const paymentPlanSchema = z.object({
  id: z.string(),
  tenantId: z.string(),
  receivableId: z.string(),
  totalAmount: z.number().nonnegative(),
  remainingAmount: z.number().nonnegative(),
  installments: z.array(paymentPlanInstallmentSchema),
  status: z.enum(['active', 'completed', 'defaulted', 'cancelled'] as const),
  startDate: z.string(),
  endDate: z.string().optional(),
  numberOfInstallments: z.number().int().positive(),
  createdBy: z.string(),
  createdAt: z.string(),
  updatedAt: z.string().optional(),
});

export type PaymentPlan = z.infer<typeof paymentPlanSchema>;
